import { render, staticRenderFns } from "./AddCategorySidebar.vue?vue&type=template&id=4c35ec9e"
import script from "./AddCategorySidebar.vue?vue&type=script&lang=js"
export * from "./AddCategorySidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports